module.exports = "/virtual-football-league/img/amblems/right/logos/Inter.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Inter.png
// module id = 2203
// module chunks = 4